import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
// The following are the scenarios where the language pack is set separately. When setting it separately, the language pack needs to be imported separately
const messages = {
  'en': require('./i18n/en'),    // English language pack
  'zh': require('./i18n/zh'),   // Chinese language pack
  // 'fr': require('./i18n/fr'),   // french language pack
  // 'sp': require('./i18n/sp'),  // spanish language pack
}

// Finally export default, this step must be written.
export default new VueI18n({
  locale : 'en', // set locale displays English by default
  messages,
  silentTranslationWarn: true,
})



// WEBPACK FOOTER //
// ./src/utils/i18n.js